export const legalPages = {
  "privacy-policy": {
    title: "Privacy Policy",
    seoTitle: "Privacy Policy | Allcov",
    updated: "22 September 2026",
    sections: [
      {
        h: "1. Who we are",
        paras: [
          'ALLCOV LLP ("Allcov", "we", "us"), LLPIN ACQ-7779, registered office at Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301, runs allcov.com and the Quikpik apps and websites. This policy explains what personal data we collect, why, and the rights you have under the Digital Personal Data Protection Act, 2023 and other Indian laws.',
        ],
      },
      {
        h: "2. What we collect",
        bullets: [
          "When you contact us (form, WhatsApp, call or email): your name, phone number, email, business name and type, and your message.",
          "When you become a client: billing details (business name, address, GSTIN), the content you share for your project, and access to accounts you ask us to manage, such as your domain, Google Business Profile or WhatsApp Business.",
          "When you use Quikpik as a customer: your name, phone number, order history and pickup details. Payments are processed by Razorpay. We never see or store your card number, UPI PIN or bank login.",
          "When a cafe joins Quikpik: business details, owner name and contact, GSTIN, FSSAI number, bank account and PAN. These are shared with Razorpay so it can settle payments to the cafe.",
          "Automatically: device and browser details, pages visited and how you use our sites, through cookies and analytics tools (Google Analytics and our website platform's analytics, which may record de-identified session replays).",
        ],
      },
      {
        h: "3. Why we use it",
        paras: [
          "To reply to enquiries and send quotes; deliver the services you buy; send invoices and keep tax records; run Quikpik orders, tell the cafe about your order, update pickup status and process refunds; keep our sites secure and prevent fraud; improve our services; and meet legal requirements. We do not sell personal data. We send marketing messages only if you agree, and you can stop them anytime by replying STOP.",
        ],
      },
      {
        h: "4. Legal basis",
        paras: [
          "Your consent, which you give when you submit a form or use our apps and can withdraw at any time; and uses the law allows without consent, such as complying with tax laws.",
        ],
      },
      {
        h: "5. Who we share it with",
        paras: [
          "Only what each needs: our website and app platform (Emergent), database provider (Supabase), payment gateway (Razorpay), Google (Workspace, Analytics, Sheets), Meta (WhatsApp), the cafe preparing your Quikpik order, our chartered accountant, and government authorities when the law requires it.",
        ],
      },
      {
        h: "6. Where it is stored",
        paras: [
          "Some of these providers store data on servers outside India. We use established providers with strong security, and follow Indian rules on data transfers.",
        ],
      },
      {
        h: "7. How long we keep it",
        paras: [
          "Enquiries: up to 24 months after our last contact. Client project data: during the project and 90 days after. Invoices and Quikpik order records: as long as Indian tax and accounting laws require. Analytics data: up to 14 months.",
        ],
      },
      {
        h: "8. Security",
        paras: [
          "Only people who need the data can access it. Our accounts use two-factor authentication and our sites use encrypted (HTTPS) connections. No system is fully secure; if a breach affects your data, we will inform you and the authorities as the law requires.",
        ],
      },
      {
        h: "9. Your rights",
        paras: [
          "You can ask us to: show what personal data we hold about you; correct or update it; erase it (unless the law requires us to keep it); withdraw your consent; resolve a grievance; and nominate someone to act for you in case of death or incapacity. Write to our Grievance Officer below.",
        ],
      },
      {
        h: "10. Children",
        paras: [
          "Our services are not meant for anyone under 18. We do not knowingly collect a child's data without verifiable parental consent. If you believe a child has shared data with us, contact us and we will delete it.",
        ],
      },
      {
        h: "11. Cookies",
        paras: [
          "We use essential cookies to run our sites and analytics cookies to understand how they are used. You can block cookies in your browser settings; some features may then not work.",
        ],
      },
      {
        h: "12. Changes",
        paras: [
          "If we change this policy, we will update the date above and show a notice on the site for significant changes.",
        ],
      },
      {
        h: "13. Grievance Officer",
        paras: [
          "Kaushlesh Agarwal, ALLCOV LLP, Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301 · info.allcov@gmail.com · +91-70650-28801. We acknowledge every request within 48 hours and resolve it within 30 days. If you are not satisfied, you may complain to the Data Protection Board of India.",
        ],
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    seoTitle: "Terms of Service | Allcov",
    updated: "22 September 2026",
    sections: [
      {
        h: "1. About these terms",
        paras: [
          'These terms apply when you use allcov.com, buy any service from ALLCOV LLP ("Allcov", "we"), or use Quikpik. By doing so, you agree to them.',
        ],
      },
      {
        h: "2. Quotes and scope",
        paras: [
          "Every project starts with a written quote listing deliverables, revision rounds, timeline and price. Anything not in the quote is a change request, priced and agreed before we start it. Quotes are valid for 15 days.",
        ],
      },
      {
        h: "3. Prices and payment",
        paras: [
          "Prices are in Indian Rupees, plus 18% GST. Projects: 50% advance before we start, 50% before go-live. Monthly plans are billed in advance on the 1st and due within 7 days. Third-party costs (domain, hosting, paid plugins, stock images, Meta's WhatsApp charges, ad spend) are paid by you directly or reimbursed at cost. Allcov is an Udyam-registered micro enterprise: under the MSMED Act, 2006, payment is due within the agreed period (never more than 45 days), and late payments attract interest as that Act provides. We may pause work and monthly services if an invoice is unpaid for more than 15 days.",
        ],
      },
      {
        h: "4. Timelines and your part",
        paras: [
          "Timelines start when we receive the advance and all your content. Delays in content, feedback or approvals move the timeline by the same number of days. If we hear nothing from you for 30 days, we may close the project and bill for work done.",
        ],
      },
      {
        h: "5. Revisions",
        paras: [
          "You get the revision rounds listed in your quote. Extra changes cost ₹1,000 per hour plus GST, or a quoted amount, agreed before we do them.",
        ],
      },
      {
        h: "6. Ownership",
        paras: [
          "Once you have paid in full, we transfer to you, in writing, the copyright in the final deliverables we create for you (logo, designs, website code and content), for the full term of copyright, worldwide. Domains, hosting, Google, WhatsApp and similar accounts are registered in your name; we work through access you give us. Third-party items (fonts, stock images, plugins, platform code) stay under their own licences. Until full payment, all rights stay with Allcov. We may show finished work in our portfolio unless you ask us in writing not to.",
        ],
      },
      {
        h: "7. Monthly plans",
        paras: [
          "Care plans, automation maintenance and retainers run month to month unless your quote says otherwise. Cancel with 30 days' written notice (WhatsApp or email is fine). When a plan ends, we hand over all access and files within 7 working days.",
        ],
      },
      {
        h: "8. Operations executives",
        paras: [
          "Executives we provide are hired, trained and managed by Allcov. You give work instructions, tools and access. They do not handle cash or sign on your behalf unless agreed in writing. If you directly hire an executive we placed with you, during the engagement or within 12 months after, a placement fee equal to 3 months of their monthly fee applies.",
        ],
      },
      {
        h: "9. Third-party platforms",
        paras: [
          "Our work relies on platforms such as Google, Meta/WhatsApp, Razorpay and hosting providers. We are not responsible for their outages, price changes, policy changes or actions on your account, for example WhatsApp restricting a number used against its rules.",
        ],
      },
      {
        h: "10. AI tools",
        paras: [
          "We use AI tools to work faster. A person reviews every deliverable before handover.",
        ],
      },
      {
        h: "11. Your responsibilities",
        paras: [
          "You confirm that the content you give us is yours or that you have the right to use it, and that you will use our work lawfully. Healthcare, education and other regulated businesses are responsible for following their own advertising and professional rules.",
        ],
      },
      {
        h: "12. Warranty",
        paras: [
          "We fix bugs in work we built, free of charge, for 30 days after go-live. We do not guarantee specific results such as search rankings, leads or sales.",
        ],
      },
      {
        h: "13. Confidentiality",
        paras: [
          "Each side keeps the other's confidential information private, during and after the work.",
        ],
      },
      {
        h: "14. Limitation of liability",
        paras: [
          "Our total liability for any claim is limited to the fees you paid us in the 3 months before the claim. We are not liable for indirect losses such as lost profits or data, except where the law does not allow this limit.",
        ],
      },
      {
        h: "15. Ending a project",
        paras: [
          "Either side can end a project with written notice. You pay for work done until then. Refunds follow our Refund & Cancellation Policy.",
        ],
      },
      {
        h: "16. Quikpik",
        paras: [
          "Quikpik is a technology platform run by Allcov that lets customers pre-order from partner cafes and pick up at the counter. The cafe prepares and sells the food and is responsible for its quality, hygiene, licences (including FSSAI), and the accuracy of its menu and prices. Payments are processed by Razorpay. Cafes also sign a separate Quikpik partner agreement.",
        ],
      },
      {
        h: "17. Law and courts",
        paras: [
          "These terms are governed by the laws of India. Courts at Gautam Buddha Nagar (Noida), Uttar Pradesh have exclusive jurisdiction.",
        ],
      },
      {
        h: "18. Contact",
        paras: [
          "ALLCOV LLP, Ground Floor, D-9, Vyapar Marg, Sector 3, Noida, Uttar Pradesh 201301 · info.allcov@gmail.com · +91-70650-28801",
        ],
      },
    ],
  },
  "refund-policy": {
    title: "Refund & Cancellation Policy",
    seoTitle: "Refund & Cancellation Policy | Allcov",
    updated: "22 September 2026",
    sections: [
      {
        h: "A. Allcov services (design, websites, automation, SOPs, operations)",
        bullets: [
          "Before work starts (before the kick-off call or first design): cancel and we refund your full advance, minus payment-gateway charges, within 7 working days.",
          "After work starts: the advance is non-refundable, as it covers work already done.",
          "Logo promise: if neither of the first two logo concepts works for you, you can cancel and we refund 50% of the logo fee. Final files are not handed over in that case.",
          "Launch Kit promise: if we miss the 10-working-day delivery for reasons on our side, after receiving your content on time, we refund 10% of the Launch Kit fee.",
          "Monthly plans (care plans, automation maintenance, retainers, operations executives): cancel with 30 days' written notice. The month already billed is not refunded, and there are no part-month refunds.",
          "Third-party costs (domains, hosting, paid plugins, stock images, Meta charges) cannot be refunded once purchased.",
          "Approved refunds go back to the original payment method within 7 working days.",
        ],
      },
      {
        h: "B. Quikpik — customers",
        bullets: [
          "Before the cafe accepts your order: you can cancel in the app and get a full refund automatically.",
          "After the cafe accepts: the order cannot be cancelled, because the food is being prepared.",
          "If the cafe cancels or cannot complete your order: you get a full refund automatically.",
          "Wrong or missing item: tell the cafe at the counter, or report it in the app within 2 hours of pickup. The cafe will replace the item or refund it.",
          "Not collected: if you don't pick up your order within 60 minutes of it being marked ready, it is treated as delivered and is not refunded.",
          "Refunds go back to your original payment method through Razorpay. Banks usually take 5–7 working days to show the money.",
        ],
      },
      {
        h: "C. Quikpik — partner cafes",
        bullets: [
          "The first 30 days are free.",
          "After that, the monthly fee is billed in advance and is not refunded for the current month. Cancel with 30 days' written notice.",
          "Commission is charged only on completed orders. Refunded orders carry no commission.",
        ],
      },
      {
        h: "D. How to ask for a refund",
        paras: [
          "WhatsApp +91-70650-28801 or email info.allcov@gmail.com with your invoice or order number. We reply within 2 working days.",
        ],
      },
    ],
  },
};
